import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import iptracker from '../../../../views/components/commonfunction/iptracker';

export default {
  name: 'changeinvoicequantity',
  components: {
    //VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    Utility,
    vueMultiSelect,
    iptracker,
    Loader
  },
  data: function() {
    return {
      awbnumber: '',
      invoicequantity:'',
      isLoading:false,
      userdetail:{},
      showInvoiceQuantity:false,
      comments:''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userdetail = userdetail;
  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.UpdateInvoiceQuantity();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    reset() {
      this.awbnumber = '';
      this.invoicequantity = '';
      this.showInvoiceQuantity = false;
    },
  async getInvoiceQuantity(){
      try {
        let InputPayload = {
          awbnumber: this.awbnumber,
        }
        this.isLoading = true;
        let result = await Utility.getInvoiceQuantity(InputPayload);
        if(result.data.code == 200){
          if(result.data.data.bookingstatus == 'Rapid'){
            if(result.data.data.updatednoofinvoices){
              this.invoicequantity = result.data.data.updatednoofinvoices;
            }else{
              this.invoicequantity = result.data.data.numberofinvoices;
            }
            this.showInvoiceQuantity = true;
          }else{
            this.$alert("Cannot Update Invoice For Complete Booking","","error");
          }
        }else{
          this.$alert(result.data.message,"","error");
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    getTraceIP(data) {
      try {
        let payload = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/changeinvoicequantity',
          "meta" : {
            "event" : `Change Invoice Quantity`,
            "data" : data
          }
      }
      let result = iptracker.getTraceIP(payload);
      } catch (error) {
        console.log(error)
      }
      
    },
    async UpdateInvoiceQuantity(){
        try {
          let InputPayload = {
            awbnumber: this.awbnumber,
            invoicequantity: this.invoicequantity,
            comments:this.comments
          }
          this.isLoading = true;
          let result = await Utility.getInvoiceQuantity(InputPayload);
          if (result.data.code == 200) {
              this.$alert(result.data.message,"","success");
              this.getTraceIP(InputPayload)
          } else {
              this.$alert(result.data.message,"","error");
          }
          this.isLoading = false;
        } catch (err) {
          console.log(err);
          this.isLoading = false;
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/changeinvoicequantity/changeinvoicequantity.component.js